import React, { useState, useEffect, useMemo } from 'react'

import Preview from 'src/fancy/waves/Preview'
import Waves from 'src/fancy/waves/Waves'
import Confetti from 'src/fancy/falling-confetti/Confetti'

import cloudinaryUrl from 'src/utils/cloudinaryUrl'

const Background = ({ config, fancyBackgrounds, impactColors }) => {
  const [ image, setImage ] = useState(config.background_image)
  const [ opacity, setOpacity ] = useState(() => Number(!!image))

  const fancyBackground = useMemo(() =>
    config.fancy_background_id &&
    fancyBackgrounds.find(f => f.id == config.fancy_background_id) || null
  , [ config.fancy_background_id ])

  useEffect(() => {
    if (config.background_image) {
      setOpacity(1)
      setImage(config.background_image)
    } else {
      setOpacity(0)
      setTimeout(() => setImage(null), 510)
    }
  }, [ config.background_image ])

  return (
    <div className="position-absolute" style={{
      transition: 'background-color 1s',
      backgroundColor: config.background_color,
      inset: 0,
      zIndex: -1,
    }}>
      {
        fancyBackground
      ? <>
          <Preview config={fancyBackground.config} />
          <Waves config={fancyBackground.config} />
        </>
      : <div className="position-absolute" style={{
          backgroundImage: image && `url('${cloudinaryUrl(image, {
            crop: 'pad',
            width: 2560,
            height: 1440,
            background: config.background_color || 'black',
            quality: 'auto',
            fetch_format: 'auto',
          })}')`,
          backgroundRepeat: 'no-repeat',
          zIndex: -1,
          transition: 'inset 1s, opacity 0.5s',
          opacity,
          ...(() => {
            switch (config.background_image_placement) {
            case 'full_screen':
              return {
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                inset: 0,
              }
            case 'scaled_to_fit':
              return {
                backgroundPosition: 'left center',
                backgroundSize: 'contain',
                inset: '3.8rem 12rem 4.5rem 0.5rem',
              }
            }
          })()
        }}></div>
      }
      {
        !fancyBackground && config.confetti &&
        <Confetti impactColors={impactColors} />
      }
    </div>
  )
}

export default Background
